import React, { useState, useEffect } from "react";

const COOKIE_KEY = process.env.REACT_APP_ORG_NAME + "_cookie_consent";
const font =
  '"Roboto Condensed", "Helvetica Neue", Helvetica, Arial, sans-serif';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_KEY);
    if (!consent) setVisible(true);
  }, []);

  if (!visible) return null;

  const handleAccept = () => {
    localStorage.setItem(COOKIE_KEY, "accepted");
    setVisible(false);
  };

  return (
    <div style={s.bar}>
      {/* Línea de color superior — degradado con colores de marca */}
      <div style={s.colorLine} />

      <div style={s.inner}>
        <p style={s.text}>
          En Casaideas queremos ofrecerte la mejor experiencia de compra
          resguardando tu privacidad. Utilizamos cookies funcionales, de
          análisis y de personalización según se describe en nuestra política de
          privacidad.{" "}
          <a href="/pages/terminos_y_condiciones" style={s.link}>
            política de privacidad
          </a>
          . ¿Aceptas el uso de cookies?
        </p>

        <button style={s.btn} onClick={handleAccept}>
          ACEPTAR COOKIES
        </button>
      </div>

      <style>{`
        @media (max-width: 600px) {
          .ci-cookie-inner {
            flex-direction: column !important;
            gap: 14px !important;
          }
          .ci-cookie-btn {
            width: 100% !important;
          }
        }
      `}</style>
    </div>
  );
}

const s = {
  bar: {
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 9999,
    background: "#fff",
    boxShadow: "0 -2px 16px rgba(0,0,0,0.10)",
    fontFamily: font,
  },
  colorLine: {
    height: "4px",
    background:
      "linear-gradient(90deg, #d50032 0%, #c4607a 25%, #b07a9e 50%, #dbc1dd 75%, #dbc1dd 100%)",
  },
  inner: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "20px",
    padding: "20px 32px",
    maxWidth: "1200px",
    margin: "0 auto",
    flexWrap: "wrap",
  },
  text: {
    flex: 1,
    minWidth: "200px",
    fontSize: "13px",
    color: "#696158",
    lineHeight: "1.6",
    margin: 0,
    textAlign: "justify",
  },
  link: {
    color: "#d50032",
    textDecoration: "underline",
  },
  btn: {
    flexShrink: 0,
    background: "#3a3a3a",
    color: "#fff",
    border: "none",
    borderRadius: "30px",
    padding: "13px 28px",
    fontSize: "13px",
    fontFamily: font,
    fontWeight: 700,
    letterSpacing: "1px",
    cursor: "pointer",
    whiteSpace: "nowrap",
  },
};
